import axios from 'axios';

export default {
  get: (params) => axios.get('/api/v1/avg/tras', { params }),
};
